const colors = [
    '#D9D9D9',
    '#90E9D5',
    '#DC6999',
    '#B1AFCD',
    '#B4DAB4',
    '#CBF2DB',
    '#FCD9C0',
    '#C5E6F4',
    '#DDDDF3',
    '#C5F0E6',
    '#E3B2C7',
    '#CDC8AF',
    '#DABFB4',
    '#D5BFF0',
    '#D3FCC0',
    '#F4F0C5',
];

export const randomColor = colors[(Math.floor(Math.random() * colors.length))];